import MuiFormLabel from '@mui/material/FormLabel';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

type FormLabelProps = ComponentPropsWithoutRef<typeof MuiFormLabel>;
type FormLabelRef = ComponentRef<typeof MuiFormLabel>;

const FormLabel = forwardRef<FormLabelRef, FormLabelProps>((props, ref) => {
  return <MuiFormLabel ref={ref} {...props} />;
});
FormLabel.displayName = 'FormLabel';
export default FormLabel;
